import Alert, { SeverityType } from './Alert';

export { SeverityType };

export default Alert;
